import { EnumOption } from "./enum-option"

/** Mirrors GIP.CM.Domain.TaskStatus */
export const TaskStatus = {
    NotCompleted: 0,
    Completed: 1,
    Approved: 2,
    Rejected: 3,
    Reassigned: 4,
    Cancelled: 5,
} as const;

export type TaskStatusValue = (typeof TaskStatus)[keyof typeof TaskStatus];

export const TaskStatusList: EnumOption[] = [
    { value: TaskStatus.NotCompleted, label: 'Assigned' },
    { value: TaskStatus.Completed, label: 'Submitted' },
    { value: TaskStatus.Approved, label: 'Approved' },
    // { value: TaskStatus.Rejected, label: 'Rejected' },
    { value: TaskStatus.Reassigned, label: 'Reassigned' },
    { value: TaskStatus.Cancelled, label: 'Cancelled' },
]
